import { ClientAccount } from "../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { SubAccountTypeHelper } from "../../Common/Helpers/SubAccountTypeHelper";
import { MaxGiaCount } from "./Contents";

export class ClientAcountHelper {
    public static MaxGiaCountHit(clientAccount: ClientAccount): boolean {
        if (clientAccount == null) {
            return false;
        }
        return (
            clientAccount.SubAccounts.filter((x) => SubAccountTypeHelper.isPP(x.SubAccountType)).length >= MaxGiaCount
        );
    }
}
